<template>
  <div class="page-wrapper">
    <SideNav />

    <div class="container">
      <PortalHeader
        :shrink="shrinkHeaderActive"
        :shrink-height="shrinkHeaderHeight"
      />

      <main
        id="main-content"
        ref="content"
      >
        <slot>
          <router-view class="inner-content" />
        </slot>
      </main>
      <div id="lf-suite-webeo-portal-reporting-v2" />

      <TutorialModal />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SideNav from './SideNav.vue';
import PortalHeader from './PortalHeader.vue';
import TutorialModal from './TutorialModal.vue';
import config from '../setup/config';

export default {
  components: {
    SideNav,
    PortalHeader,
    TutorialModal,
  },
  data: () => ({
    shrinkHeaderActive: false,
    shrinkHeaderHeight: 50,
    shrinkHeaderTrigger: 150,
  }),
  computed: {
    ...mapGetters([
      'hasClientFeature',
    ]),
  },
  mounted() {
    const embedDiv = document.getElementById('lf-suite-webeo-portal-reporting-v2');
    const mainContent = document.getElementById('main-content');

    const mainJsUrl = `${config.microfrontends.reportinguiv2}/assets/main.js`;
    const mainCssUrl = `${config.microfrontends.reportinguiv2}/assets/main.css`;

    const existingScript = document.querySelector(`script[src="${mainJsUrl}"]`);
    if (!existingScript && this.hasClientFeature('WebeoReportingV2')) {
      const script = document.createElement('script');
      script.setAttribute('src', mainJsUrl);
      script.async = true;
      document.head.appendChild(script);
    }

    const existingLink = document.querySelector(`link[href="${mainCssUrl}"]`);
    if (!existingLink && this.hasClientFeature('WebeoReportingV2')) {
      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', mainCssUrl);
      document.head.appendChild(link);
    }

    if (window.location.pathname.startsWith('/ReportingV2')) {
      embedDiv.style.display = 'block';
      mainContent.style.display = 'none';
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.content.addEventListener('scroll', () => {
        if (this.shrinkHeaderActive
          && this.$refs.content.scrollTop
          <= this.shrinkHeaderTrigger - this.shrinkHeaderHeight - 1) {
          this.shrinkHeaderActive = false;
        } else if (!this.shrinkHeaderActive && this.$refs.content.scrollTop
          > this.shrinkHeaderTrigger) {
          this.shrinkHeaderActive = true;
        }
      });
    });
  },
};
</script>

<style scoped>
.page-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row;
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

main {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
}

.content {
  width: 100%;
  display: block;
  justify-content: center;
}

.inner-content {
  min-height: 0 !important;
  width: 100%;
}

#lf-suite-webeo-portal-reporting-v2 {
  display: none;
}
</style>
